enum SkapaDurationEnum {
	instant = '0ms',
	quick = '100ms',
	standard = '200ms',
	slow = '250ms'
}

export default SkapaDurationEnum;
